<template>
    <section>
      <h3 class="centered-text">Additional Products that will Help Make your Lawn or Garden Grow Even Better!</h3>

      <ul class="products">
        <li v-for="item in otherItems" :key="item.id">
          <line-item
            :item="item"
            @addItem="addToCart"
            @removeFromCart="removeFromCart"
            :qtyInCart="qtyInCart(item)"
            :showDiscount="false"
          />
        </li>
      </ul>

    </section>
</template>

<script>
import LineItem from '../../../containers/orders/lineItem.vue';

export default {
  name: 'Fertilizer',

  components: {
    LineItem,
  },

  data() {
    return {
      localItems: [],
    };
  },

  computed: {
    /**
     * List of fertilizer/other products
     */
    otherItems() {
      return this.$store.state.otherItems;
    },

    storeOtherItems() {
      return this.$store.getters.otherItemArray;
    },
  },

  methods: {
    addToCart(otherProductItem) {
      if (otherProductItem.quantity > 0) {
        const data = {
          itemType: 'otherProductLineItems',
          item: otherProductItem,
        };

        this.$store.commit('setProperties', { showFlyout: true });
        this.$store.dispatch('addLineItem', data);
      }
    },

    removeFromCart(otherProductItem) {
      const data = {
        itemType: 'otherProductLineItems',
        item: otherProductItem,
      };
      this.$store.dispatch('removeLineItem', data);
    },

    qtyInCart(item) {
      const foundInCart = this.storeOtherItems.find((product) => product.id === item.id);

      if (foundInCart) {
        return parseInt(foundInCart.quantity, 10) || 0;
      }

      return 0;
    },
  },
};
</script>

<style scoped>

@media (max-width: 640px) {
  .products {
    justify-content: flex-start;
  }

  .products li {
    max-width: calc(50% - 5.24em);
  }

  .location-bar {
    flex-direction: column;
    align-items: center;
  }
}

@media (max-width: 480px) {
  .products li {
    max-width: calc(100% - 5.24em);
  }

  .products {
    flex-direction: column;
  }

  .location-bar {
    flex-direction: column;
    align-items: center;
  }
}

</style>
